import { render, staticRenderFns } from "./ReseteosForm.vue?vue&type=template&id=c9f4e2ee&"
import script from "./ReseteosForm.vue?vue&type=script&lang=js&"
export * from "./ReseteosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports